/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React from 'react';
import { styled } from 'styled-components';
import { getContent } from './base-content';
import { SmartLink } from './SmartLink';
import { baseStyle, colorSets, fontBySize } from './styles';
import SvgChevron from '../../../../play-core/icons/Chevron';
import SvgExternalLink from '../../../../play-core/icons/ExternalLink';
import { jsx as _jsx } from "react/jsx-runtime";
const getDefaultIcon = isInternal => isInternal ? /*#__PURE__*/_jsx(SvgChevron, {
  orientation: "right"
}) : /*#__PURE__*/_jsx(SvgExternalLink, {});
export const Link = ({
  ariaLabel,
  colorSet = colorSets.primary,
  expand = false,
  fontType = 'Regular',
  icon,
  iconPositionRight = false,
  iconSize = 24,
  iconIndicator = false,
  isDisabled = false,
  isInternal = false,
  leftAligned = false,
  openInNewTab = false,
  showDefaultIcon = false,
  size = 'default',
  to,
  fontSize = fontBySize[size],
  ...rest
}) => {
  const text = rest.type === 'text' ? rest.text : undefined;
  return /*#__PURE__*/_jsx(StyledLink, {
    colorSet,
    expand,
    fontType,
    fontSize,
    iconPositionRight,
    isDisabled,
    isInternal,
    leftAligned,
    openInNewTab,
    size,
    textColor: colorSet.color,
    to,
    ...rest,
    isActive: false,
    ariaLabel: ariaLabel,
    children: getContent({
      fontType,
      fontSize,
      icon: showDefaultIcon ? getDefaultIcon(isInternal) : icon,
      iconColor: colorSet.iconColor,
      iconSize,
      iconPositionRight,
      iconIndicator,
      multilineText: rest.multilineText,
      text
    })
  });
};
const StyledLink = styled(({
  ariaLabel,
  children,
  className,
  isDisabled,
  isInternal,
  onClick,
  openInNewTab,
  rel,
  state,
  to,
  download
}) => /*#__PURE__*/_jsx(SmartLink, {
  "aria-label": ariaLabel,
  children: children,
  className: className,
  isInternal: isInternal,
  onClick: onClick,
  rel: rel,
  state: state,
  tabIndex: isDisabled ? -1 : 0,
  target: openInNewTab ? '_blank' : '_self',
  to: to,
  download: download
})).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-dg5cv5-0"
})(["", ";"], baseStyle);
export const PrimaryLink = props => Link({
  colorSet: colorSets.primary,
  ...props
});
export const SecondaryLink = props => Link({
  colorSet: colorSets.secondary,
  ...props
});
export const AlertLink = props => Link({
  colorSet: colorSets.alert,
  ...props
});
export const TransparentLink = props => Link({
  colorSet: colorSets.transparent,
  ...props
});